export const GET_TAGS = "GET_TAGS";
export const GET_TAG_BY_ID = "GET_TAG_BY_ID";
export const UPDATE_TAG = "UPDATE_TAG";
export const DELETE_TAG = "DELETE_TAG";
export const CREATE_TAG = "CREATE_TAG";
